const newsletterSignup = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'newsletterSignup'
    });
};

const formSubmission = (formName, optIn) => {
    window.dataLayer = window.dataLayer || [];

    let interaction = {
        event: 'formbuilder_submit',
        attributes: {
            form_id: formName,
        }
    };

    if (optIn != null) {
        interaction.attributes.opt_in_checkbox = optIn;
    }
    window.dataLayer.push(interaction);
};

const viewEventDetailsClick = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'viewEventDetailsClick',
        attributes: event
    });
};

const storyCalloutClick = (callout) => {
    let calloutType = $(callout[0].children[1])[0].innerText;
     window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'Callout Interaction',
        attributes: {
            callout: calloutType,
            type: 'Story Callout',
            clickText: calloutType,
            clickURL: '(not set)'
        }
    });
};

const expandedStoryCalloutClick = (type, ctaText, ctaUrl) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'Callout Interaction',
        attributes: {
            callout: type,
            type: 'Story Callout',
            clickText: ctaText,
            clickURL: ctaUrl
        }
    });
};

const cardClick = (section, type, cardTitle, url, learnMore) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'Internal CTA Interaction',
        attributes: {
            section,
            type,
            title: cardTitle,
            clickURL: url,
            learnMoreText: learnMore
        }
    });
};

export default {
    newsletterSignup,
    formSubmission,
    viewEventDetailsClick,
    storyCalloutClick,
    expandedStoryCalloutClick,
    cardClick
};